import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecipientDropdownComponent } from './recipient-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [RecipientDropdownComponent],
  exports: [RecipientDropdownComponent]
})
export class RecipientDropdownModule { }
